// test20
(20 && 0);
